import React from "react";
import { useIntl } from "react-intl";
import { Box, Tabs, Tab, Chip } from "@mui/material";

const CompanyTabsSection = ({ company, tabActive, onChange, children }) => {
  const intl = useIntl();
  const jobOffers = company?.job_offers || [];
  const projects = company?.projects || [];
  const milestones = company?.company_milestones || [];

  const tabs = [
    { id: "profile", label: intl.formatMessage({ id: "company_view.tabs.profile" }) },
    ...(milestones.length > 0
      ? [{ id: "history", label: intl.formatMessage({ id: "company_view.tabs.history" }) }]
      : []),
    ...(projects.length > 0
      ? [{ id: "projects", label: intl.formatMessage({ id: "company_view.tabs.projects" }) }]
      : []),
    ...(jobOffers.length > 0
      ? [{ id: "jobs", label: intl.formatMessage({ id: "company_view.tabs.jobs" }) }]
      : []),
  ];

  return (
    <Box
      sx={{
        mx: "auto",
        maxWidth: "72rem",
        px: { xs: "1rem", md: "2rem" },
        mt: "1.5rem",
      }}
    >
      <Box
        sx={{
          borderBottom: "1px solid hsl(214.3, 31.8%, 91.4%)",
        }}
      >
        <Tabs
          value={tabActive}
          onChange={onChange}
          TabIndicatorProps={{
            style: {
              backgroundColor: "hsl(152, 60%, 32%)",
              height: 3,
              borderRadius: "3px 3px 0 0",
            },
          }}
          sx={{
            minHeight: 0,
            "& .MuiTabs-flexContainer": {
              gap: "0.25rem",
            },
          }}
        >
          {tabs.map((tab) => (
            <Tab
              key={tab.id}
              value={tab.id}
              label={tab.label}
              disableRipple
              sx={{
                textTransform: "none",
                fontSize: "0.875rem",
                minHeight: 0,
                minWidth: 0,
                py: "0.75rem",
                px: "1.25rem",
                color: "hsl(215.4, 16.3%, 46.9%)",
                "&.Mui-selected": {
                  color: "hsl(222.2, 84%, 4.9%)",
                  fontWeight: 600,
                },
                fontFamily: "Segoe UI Semibold, system-ui, sans-serif",
              }}
              icon={
                tab.id === "jobs" ? (
                  <Chip
                    label={jobOffers.length}
                    size="small"
                    sx={{
                      height: "1.25rem",
                      minWidth: "1.25rem",
                      ml: "0.25rem",
                      fontSize: "0.625rem",
                      fontFamily: "Segoe UI Semibold, system-ui, sans-serif",
                      bgcolor: "hsl(152, 60%, 32%)",
                      color: "hsl(0, 0%, 100%)",
                      borderRadius: "999px",
                      "& .MuiChip-label": { px: "0.375rem" },
                    }}
                  />
                ) : null
              }
              iconPosition="end"
            />
          ))}
        </Tabs>
      </Box>

      <Box sx={{ py: "2.5rem" }}>{children}</Box>
    </Box>
  );
};

export default CompanyTabsSection;
